import React from 'react'
import { Link } from 'gatsby'
import { Flex, Box, Heading, Text, Button } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import Icomoon from '../Icomoon'

const CombiningSection = () => {
  const { t } = useTranslation('home')
  const combiningFeatures = t('combining.features', { returnObjects: true })

  return (
    <Box as="section" width={1} pt={[20, 25, 32]} px={[5, 5, 0]} pb={20}>
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        maxWidth="container"
        mx="auto"
      >
        <Heading maxWidth={['330px', '800px', '920px']} mb={7} variant="level2" textAlign="center">
          {t('combining.title')}
        </Heading>

        <Text
          as="p"
          maxWidth={['280px', '400px', 'unset']}
          mb={[12, 16]}
          variant="level5"
          textAlign="center"
        >
          {t('combining.subtitle')}
        </Text>

        <Flex
          justifyContent={['space-between', 'space-around', 'space-between']}
          flexWrap="wrap"
          width={1}
        >
          {Object.entries(combiningFeatures).map(([key, value]) => (
            <Box
              key={key}
              flex={['0 100%', '0 50%', 'unset']}
              width={[1, '270px']}
              height="100%"
              mb={[9, 9, 0]}
              pt={7}
              px={6}
              pb={6}
              textAlign={['center', 'center', 'left']}
              sx={{
                transition: 'all .325s ease-in-out',
                ':hover': {
                  background: 'white',
                  boxShadow: '0px 30px 80px rgba(33, 47, 64, 0.1)',
                  borderRadius: '10px'
                }
              }}
            >
              <Flex
                alignItems="center"
                justifyContent="center"
                width="100px"
                height="100px"
                mx={['auto', 'auto', 0]}
                sx={{
                  borderRadius: '50%',
                  background: `${value.background}`
                }}
              >
                <Icomoon icon={key} color="white" size="44px" />
              </Flex>

              <Heading
                width={[1, 1, 1 / 2]}
                mt={5}
                mb={3}
                variant="level3"
                fontSize="23px"
                lineHeight="143%"
                letterSpacing="0.15px"
              >
                {value.title}
              </Heading>

              <Text as="p" width={[1, 1, '200px']} px={[0, '10%', 0]} variant="level6">
                {value.description}
              </Text>
            </Box>
          ))}
        </Flex>
      </Flex>

      <Link to={t('combining.learn_more.link')}>
        <Button width={[1, '200px']} mt={[0, 9]} mx="auto" variant="quartiary">
          {t('combining.learn_more.text')}
        </Button>
      </Link>
    </Box>
  )
}

export default CombiningSection
